import type { FeaturevisorInstance } from '@featurevisor/sdk';
import type { OrganizationContextSchemaT } from '../contexts/organization-context';

export const ToolsTagsFeature = (
  sdk: FeaturevisorInstance,
  context: OrganizationContextSchemaT
) => {
  const key = 'tools-tags';

  const isEnabled = sdk.isEnabled(key, context);

  return {
    key,
    isEnabled,
  };
};
